import React from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

function EngagementIcon({ emoji, label }) {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="cursor-help select-none inline-flex"
            role="img"
            aria-label={label}
          >
            {emoji}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          <p className="text-xs">{label}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

/** Email engagement indicators shown on playbook / outreach rows. */
export default function OutreachEngagementIcons({
  openedAt,
  clickedAt,
  repliedAt,
}) {
  const hasReplied = !!repliedAt;
  const hasClicked = !!clickedAt;
  const hasOpened = !!openedAt;

  if (!hasReplied && !hasClicked && !hasOpened) return null;

  return (
    <div className="flex items-center gap-1 flex-shrink-0">
      {hasReplied && (
        <EngagementIcon emoji="💬" label="Recipient replied to this message" />
      )}
      {hasClicked && !hasReplied && (
        <EngagementIcon emoji="🔗" label="Recipient clicked a link in this message" />
      )}
      {hasOpened && !hasClicked && !hasReplied && (
        <EngagementIcon emoji="👁️" label="Recipient opened this message" />
      )}
    </div>
  );
}
